<p-buttongroup [class.fluid]="fluid()">
    @for (option of options(); track option.value; let first = $first, last = $last) {
        <btn
            [id]="option[optionValue() || '']"
            [label]="option[optionLabel() || '']"
            [severity]="model() === option.value ? 'primary' : 'secondary'"
            [size]="size()"
            [class]="getButtonClass(option, first, last)"
            [disabled]="disabled()"
            [glueLeft]="first"
            [glueRight]="last"
            (onClick)="model.set(option.value); onChange.emit(model())"></btn>
    }
</p-buttongroup>
